import React, { useState, useEffect, useCallback } from 'react';
import { getVioExternalKeyStatus } from '../services/api';
import VioExternalApiKeyModal from './VioExternalApiKeyModal';
import './VioExternalApiKey.css';

/**
 * After auth, require a VIO External API key for this tenant (LowDB, via ops UI).
 * Same pattern as miniapp-claim-v2 / luckydraw-v4 / checkin-miniapp-v4.
 */
export default function VioExternalApiKeyGate({ children }) {
  const [phase, setPhase] = useState('loading');
  const [statusError, setStatusError] = useState(null);

  const check = useCallback(async () => {
    setPhase('loading');
    setStatusError(null);
    try {
      const res = await getVioExternalKeyStatus({ verify: true });
      if (!res.success) {
        setPhase('blocked');
        setStatusError(res.message || 'Could not load API key status');
        return;
      }
      const d = res.data || {};
      const needsReconfigure = !!d.needsReconfigure;
      if (d.configured && !needsReconfigure) {
        setPhase('ready');
      } else {
        setPhase('blocked');
        if (d.verifyMessage) setStatusError(d.verifyMessage);
      }
    } catch (e) {
      const msg =
        e?.response?.data?.message || e?.response?.data?.error || e.message || 'Could not load API key status';
      setPhase('blocked');
      setStatusError(msg);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const onSaved = useCallback(() => {
    check();
  }, [check]);

  if (phase === 'loading') {
    return (
      <div className="vio-key-gate-loading">
        <div className="vio-key-gate-spinner" />
        <p className="vio-key-gate-loading-text">Checking VIO External API configuration…</p>
      </div>
    );
  }

  if (phase === 'ready') {
    return <>{children}</>;
  }

  return (
    <VioExternalApiKeyModal
      opened
      allowDismiss={false}
      statusError={statusError}
      onClose={() => {}}
      onSaved={onSaved}
      onRetryStatus={() => check()}
    />
  );
}
